import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { LoaderComponent } from '@shared/components/loader/loader.component';
import { LoaderService } from '@core/services/loader/loader.service';
import { SessionService } from '@core/services/session/session.service';
import { CookieConsentBannerComponent } from '@core/components/cookie-consent-banner/cookie-consent-banner.component';
import { GuestBannerComponent } from '@core/components/guest-banner/guest-banner.component';

@Component({
  selector: 'd2d-root',
  imports: [
    RouterOutlet,
    ToastModule,
    LoaderComponent,
    CookieConsentBannerComponent,
    GuestBannerComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <router-outlet></router-outlet>
    <p-toast />
    @if (isLoading()) {
      <d2d-loader />
    }
    <d2d-cookie-consent-banner />
    <d2d-guest-banner />
  `,
})
export class AppComponent {
  private loaderService = inject(LoaderService);
  // Se instancia al arrancar para que la verificación de sesión expirada
  // (al cargar y periódica) funcione en cualquier página.
  private readonly sessionService = inject(SessionService);

  isLoading = this.loaderService.isLoading;
}
